package com.vizio.redwolf.consent.serialization

import com.vizio.redwolf.consent.model.ConsentContent
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.JsonTransformingSerializer

/**
 * Kotlin Polymorphic Serializer requires `type` to differentiate serializers internally.
 * That field is essentially metadata SDK consumers do not need.
 *
 * This serializer makes the `type` field an internal detail instead of external
 *
 */
internal class ConsentContentNoExternalTypeSerializer : JsonTransformingSerializer<ConsentContent>(
    ConsentContent.serializer() //base on the generated serializer
) {
    override fun transformSerialize(element: JsonElement): JsonElement {
        // Remove the 'type' field before outputting
        if (element is JsonObject && element.containsKey("type")) {
            return JsonObject(element.toMutableMap().apply {
                remove("type")
            })
        }
        return element
    }

    override fun transformDeserialize(element: JsonElement): JsonElement {
        // Re-add the `type` key so that the deserializer knows which serializer to use
        var transformedElement = element // return unmodified by default
        if (element is JsonObject) {
            if (element.containsKey("textInfo")) {
                transformedElement = JsonObject(element.toMutableMap().apply {
                    put("type", JsonPrimitive("Text"))
                })
            } else if (element.containsKey("htmlInfo")) {
                transformedElement = JsonObject(element.toMutableMap().apply {
                    put("type", JsonPrimitive("HtmlCss"))
                })
            }
        }
        return transformedElement
    }
}